import { appHistory } from './history';
export const navigateTo = props => {
  appHistory.history.push(props);
};